let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cVAsh")).then(() => parcelRequire('6kqNC'));